var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Mobile, Laptop, Wifi,",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12347",
    d: "M40 40H0V0h40z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12348",
    d: "M40 40H0V0h40z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12349",
    d: "M0 0h40v40H0z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12350",
    d: "M11.667 8.542h0a3.124 3.124 0 00-3.125 3.125h0",
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12351",
    d: "M10 3.333A6.667 6.667 0 003.333 10",
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12352",
    d: "M8.333 25v-8.333",
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12353",
    d: "M30 13.333v-1.667a3.347 3.347 0 00-3.363-3.333h-9.97",
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12354",
    d: "M33.333 13.333h-6.875a3.332 3.332 0 00-3.333 3.333v15a3.332 3.332 0 003.333 3.333h6.875a3.332 3.332 0 003.333-3.333v-15a3.332 3.332 0 00-3.333-3.333z",
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12355",
    d: "M28.433 31.25h2.917",
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12356",
    d: "M23.125 25H6.667A1.667 1.667 0 005 26.667v1.667a3.332 3.332 0 003.333 3.333h14.792",
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default SvgWifi;


//////////////////
// WEBPACK FOOTER
// ./src/icons/wifi.svg
// module id = 201
// module chunks = 11